var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filter-panel" }, [
    _c("div", { staticClass: "filter-control" }, [
      _c("div", { staticStyle: { width: "100%!important" } }, [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c("div", [
            _c(
              "a",
              {
                staticClass: "text-secondary mb-0",
                attrs: { href: "javascript:void(0)" }
              },
              [
                _c("b", [
                  _vm._v(
                    _vm._s(
                      this.openFilter ? "Filtra risultati" : "Imposta filtro"
                    )
                  )
                ]),
                _c("span", [_vm._v(" | " + _vm._s(_vm.counter))])
              ]
            )
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("button", { staticClass: "btn btn-sm btn-secondary mr-2" }, [
        _vm._v("reset")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4708e00a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4708e00a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/pages/tour-accompagnati/FilterMainTourPanel.vue
// module id = null
// module chunks = 